import { render } from "./CommunityView.vue?vue&type=template&id=4eda779e&scoped=true"
import script from "./CommunityView.vue?vue&type=script&lang=js"
export * from "./CommunityView.vue?vue&type=script&lang=js"

import "./CommunityView.vue?vue&type=style&index=0&id=4eda779e&scoped=true&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-geoje\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4eda779e"]])

export default __exports__